/**
 * Détection des plantages causés par la traduction automatique du navigateur.
 *
 * Chrome traduit une page en remplaçant chaque nœud texte par un `<font>` qui
 * l'enveloppe. React, lui, garde des références directes vers ces nœuds pour
 * savoir où insérer les suivants : au rendu d'après, son
 * `parent.insertBefore(nouveau, texte)` porte sur un nœud qui n'est plus un
 * enfant de `parent`, et lève une DOMException qui remonte jusqu'à
 * l'`errorComponent` racine.
 *
 * On ne peut pas empêcher un visiteur de traduire la page : les composants
 * doivent rester robustes (jamais de nœud texte nu comme frère d'un rendu
 * conditionnel), et l'écran d'erreur doit expliquer ce qui se passe quand ça
 * arrive quand même.
 */

/**
 * Erreurs levées par React quand le DOM qu'il suit a été modifié sous ses pieds
 * (`insertBefore` / `removeChild` sur un nœud qui n'est plus au bon endroit).
 */
export function isDomReconciliationError(message: string): boolean {
  return (
    /insertBefore|removeChild|appendChild/.test(message) &&
    /not a child|n'est pas un enfant|to be removed|à supprimer|not be found/i.test(message)
  )
}

/**
 * Vrai quand le navigateur traduit la page. Chrome pose `translated-ltr` /
 * `translated-rtl` sur `<html>` et réécrit chaque nœud texte en `<font>`.
 */
export function isPageTranslated(): boolean {
  if (globalThis.document === undefined) {
    return false
  }

  const { classList } = document.documentElement
  return (
    classList.contains('translated-ltr') ||
    classList.contains('translated-rtl') ||
    document.querySelector('font[style*="vertical-align"]') !== null
  )
}
